function newsletter(campo) {
  if (validaForm('frmNewsLetter')) {
    var dados = $("#frmNewsLetter").serialize()
    jQuery.ajax({
      type: "POST",
      url: "admin/MVC/action/IncluirNewsletter.php",
      data: dados,
      success: function (msg) {
        var msg = $.trim(msg);
		if (msg == "ok"){
			$('#enviar-newsletter').text('Enviado');
			document.getElementById('frmNewsLetter').reset();
			$('#news-success').modal({show:true});
		}
        if (msg == 'aviso'){
			$('#enviar-newsletter').text('REGISTRAR');
			document.getElementById('frmNewsLetter').reset();
			$('#news-aviso').modal({show:true});
        }
        if (msg == 'erro'){
			$('#enviar-newsletter').text('REGISTRAR');
			document.getElementById('frmNewsLetter').reset();
			$('#news-interno').modal({show:true});
        }
      }
    });
  }
}

function mostraInformacoes(cod){
	$('.mais-informacoes-'+cod).toggle();
	$('.mais-informacoes-'+cod).toggleClass('informacoes-ativas');
}
function mostraInformacoes2(cod){
	$('.mais-informacoes-2-'+cod).toggle();
	$('.mais-informacoes-2-'+cod).toggleClass('informacoes-ativas-2');
}

function search(event){
	var key=event.keyCode || e.which;
	console.log(key);
	var e = $('#pesquisa-duvida').val();
	if(e.length>=3){
		var dados = 'dados=' + $('#pesquisa-duvida').val();	
		if (key==13) {
			jQuery.ajax({
				type: "POST",
				url: "admin/MVC/action/pesquisarDuvida.php",
				data:dados,
			    success: function (msg) {
			      if (msg == '-1')
			        alert('Parâmetro de consulta inválido !');
			      else
			        if (msg == 'erro')
			          alert('Ocorreu um erro ao efetuar a consulta !');
			        else {
						document.getElementById('listagem-duvidas').innerHTML = msg;
			        }
			    }
			});
		}
	}else{
		
	}
}

function testaEmail(campo){
	if(campo.value != "E-mail *" && campo.value != "E-mail"){
		var email = campo;
		if (!checkMail(email) && campo.value != '') {
			email.value = '';
			email.focus;
			$('#modalEmailInvalido').modal({show:true});
		}
	}
}

function enviarContatoNormal(){
	if (validaForm('form-contato')){
		$('#enviar-contato').text('Enviando');
		var dados =$("#form-contato").serialize()
		jQuery.ajax({
			type: "POST",
			url: "admin/MVC/action/EnviarContato.php",
			data:dados,
			success: function(msg){
				var msg = $.trim(msg);
				if (msg == "ok"){
					$('#enviar-contato').text('Enviado');
					document.getElementById('form-contato').reset();
					$('#msg-sucesso').modal({show:true});
				}
				if (msg == 'erro')
					$('#erro-interno').modal({show:true});
			}
		});
	}
}

function toggleMenuMobile() {
	$("body").toggleClass('show-menu-mobile');
	$("#hamburguer-menu-icon").toggleClass('open');

	$('.menu-mobile-wrapper').height( $(window).height() );
};

acisap ={

countUp: function(target) {
		$.fn.isInViewport = function() {
		    var elementTop = $(this).offset().top;
		    var elementBottom = elementTop + $(this).outerHeight();

		    var viewportTop = $(window).scrollTop();
		    var viewportBottom = viewportTop + $(window).height();

		    return elementBottom > viewportTop && elementTop < viewportBottom;
		};

		$.fn.countAnimate2 = function(text,params,pre,pos,end) {
			$(this).addClass('initialized')

			var count = 1;
			var time = 3000 / params.length;
			var element = this;
			var pre = pre;
			var pos = pos;
			var end = end;
			var timeout = setInterval(function(){ 
				if(params[count] !== undefined){
					count++;
					if(params[count] !== undefined){
						element.html(text+pre+params[count]+pos)
					}else{
						if(end != ''){
							element.html(text+pre+params[(count-1)]+end)
						}
					}
				}
			}, time);


		};

		if(target == '#feira-numeros'){
			if ($(target).isInViewport()) {
				if($('.count05').hasClass('initialized') === false){
					$('.count05').countAnimate([1,12,20,32,45,58,65,70,99,135,158,164,189,192,201,209,214,221,230,237],'','mil','')
				}
				if($('.count06').hasClass('initialized') === false){
					$('.count06').countAnimate([1,5,12,19,26,31,37,41,48,52,61,69,72,75],'','Mi','')
				}
				if($('.count07').hasClass('initialized') === false){
					$('.count07').countAnimate([1,52,81,120,156,162,180,275,324,408,520,600],'+','','')
				}
				if($('.count08').hasClass('initialized') === false){
					$('.count08').countAnimate([1,5,10,25,40,55,62,70,78,84,91,98],'','%','')
				}
			}
		}else{
			if ($(target).isInViewport()) {
				if($('.count01').hasClass('initialized') === false){
					var vetor=[];
					var count=0;
					while(count<26){
						vetor[count]=[count];
						count++;
					}
					$('.count01').countAnimate2('+',vetor,'','','')
				}
				if($('.count02').hasClass('initialized') === false){
					var vetor1=[];
					var count1=0;
					var pos=0;
					while(count1<101){
						vetor1[pos]=[count1];
						pos++;
						count1+=2;
					}
					$('.count02').countAnimate2('+ de ',vetor1,'','','')
				}
				if($('.count03').hasClass('initialized') === false){
					var vetor2=[];
					var count2=0;
					var pos=0;
					while(count2<401){
						vetor2[pos]=[count2];
						count2+=4;
						pos++;
					}
					$('.count03').countAnimate2('+ de ',vetor2,'','','')
				}
				if($('.count04').hasClass('initialized') === false){
					var vetor3=[];
					var count3=0;
					var pos=0;
					while(pos<88){
						vetor3[pos]=[count3];
						count3++;
						pos++;
					}
					$('.count04').countAnimate2('',vetor3,'',' anos ','')
				}
				if($('.count010').hasClass('initialized') === false){
					var vetor4=[];
					var count4=0;
					var pos=0;
					while(pos<36){
						vetor4[pos]=[count4];
						count4 += 2;
						pos++;
					}
					$('.count010').countAnimate2('',vetor4,'','','')
				}
				if($('.count011').hasClass('initialized') === false){
					var vetor5=[];
					var count5=0;
					var pos=0;
					while(pos<34){
						vetor5[pos]=[count5];
						count5 += 1;
						pos++;
					}
					$('.count011').countAnimate2('',vetor5,'',' mil PIB','')
				}
				if($('.count012').hasClass('initialized') === false){
					var vetor6=[];
					var count6=0;
					var pos=0;
					while(pos<51){
						vetor6[pos]=[count6];
						count6 += 8;
						pos++;
					}
					$('.count012').countAnimate2('',vetor6,'',' mil PIB','')
				}
			}
		}
	},
}